import { createSlice } from '@reduxjs/toolkit';
import { MapAuthorsState } from './mapAuthors.types';
import { MAP_AUTHORS_SLICE_NAME } from './mapAuthors.constants';
import {
  addMapAuthorReducer,
  deleteMapAuthorReducer,
  getMapAuthorsReducer,
  updateMapAuthorReducer,
} from './mapAuthors.reducers';

const initialState: MapAuthorsState = {
  data: {},
  loading: {},
  mutationLoading: {},
  error: null,
};

const mapAuthorsSlice = createSlice({
  name: MAP_AUTHORS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    getMapAuthorsReducer(builder);
    addMapAuthorReducer(builder);
    updateMapAuthorReducer(builder);
    deleteMapAuthorReducer(builder);
  },
});

export default mapAuthorsSlice.reducer;
